(() => {
  const peek = document.querySelector('[data-cart-peek]');
  if (!peek) return;
  const toggle = peek.querySelector('[data-cart-toggle]');
  const panel = peek.querySelector('.cart-peek-panel');
  let refreshAt = 0;
  let request = null;
  let closeTimer;
  const setOpen = open => {
    peek.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
  };
  const refresh = (force = false) => {
    if (request) return request;
    if (!force && Date.now() - refreshAt < 1500) return Promise.resolve();
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    request = fetch(root + 'cart?section_id=ouma-cart-peek', {credentials: 'same-origin'})
      .then(response => { if (!response.ok) throw Error('cart'); return response.text(); })
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('[data-cart-preview-body]');
        const count = parsed.querySelector('[data-cart-count]');
        if (fresh && count) {
          peek.querySelector('[data-cart-preview-body]').replaceChildren(...fresh.childNodes);
          const badge = peek.querySelector('[data-cart-count]');
          badge.textContent = count.textContent;
          badge.hidden = count.textContent.trim() === '0';
          refreshAt = Date.now();
        }
      }).catch(() => {}).finally(() => {request = null;});
    return request;
  };
  const open = () => {clearTimeout(closeTimer); setOpen(true); refresh();};
  peek.addEventListener('mouseenter', () => {
    if (matchMedia('(hover: hover)').matches) open();
  });
  toggle.addEventListener('focus', open);
  peek.addEventListener('mouseleave', () => {
    if (!peek.contains(document.activeElement)) closeTimer = setTimeout(() => setOpen(false), 180);
  });
  peek.addEventListener('focusout', event => {
    if (!peek.contains(event.relatedTarget)) setOpen(false);
  });
  peek.querySelector('[data-cart-close]').addEventListener('click', () => {setOpen(false); toggle.focus();});
  document.addEventListener('click', event => {if (!peek.contains(event.target)) setOpen(false);});
  document.addEventListener('keydown', event => {if (event.key === 'Escape' && peek.classList.contains('is-open')) {setOpen(false); toggle.focus();}});
  const form = document.getElementById('OumaWheyForm');
  if (form) {
    const button = form.querySelector('button[name="add"]');
    const english = document.documentElement.lang.startsWith('en');
    const message = document.createElement('p');
    message.className = 'whey-note';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.hidden = true;
    form.append(message);
    let adding = false;
    form.addEventListener('submit', async event => {
      if (!button || button.disabled || adding) { event.preventDefault(); return; }
      event.preventDefault();
      if (!form.reportValidity()) return;
      adding = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      message.hidden = false;
      message.textContent = english ? 'Adding to your bag…' : 'Tilføjer til kurven…';
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', body: new FormData(form),
          headers: {Accept: 'application/json'}, credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          message.textContent = result.description || result.message || (english ? 'This item could not be added. Please check the quantity.' : 'Varen kunne ikke tilføjes. Kontrollér antallet.');
          return;
        }
        message.textContent = english ? 'Added to your bag ✓' : 'Tilføjet til kurven ✓';
        if (request) await request;
        refreshAt = 0;
        await refresh(true);
      } catch {
        message.textContent = english ? 'We could not confirm the update. Please check your bag before trying again.' : 'Vi kunne ikke bekræfte opdateringen. Tjek din kurv, før du prøver igen.';
      } finally {
        adding = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }
  window.addEventListener('pageshow', () => {refreshAt = 0;});
})();
